import enTranslationMessages from './translations/en.json';
import frTranslationMessages from './translations/fr.json';

export const DEFAULT_LOCALE = 'en';

export const appLocales = [
	'en',
	'fr',
];

type Messages = Record<string, string>;

export const formatTranslationMessages = (locale: string, messages: Messages) => {
  const defaultFormattedMessages: Messages =
    locale !== DEFAULT_LOCALE
      ? (frTranslationMessages as Messages) // français comme base de secours
      : {};

	return Object.keys(messages).reduce((formattedMessages, key) => {
		const formattedMessage =
			!messages[key] && locale !== DEFAULT_LOCALE
				? defaultFormattedMessages[key]
				: messages[key];

		return { ...formattedMessages, [key]: formattedMessage };
	}, {} as Messages);
};

export const translationMessages: Record<string, Messages> = {
  en: formatTranslationMessages('en', enTranslationMessages as Messages),
  fr: formatTranslationMessages('fr', frTranslationMessages as Messages),
};